import { IonItem, IonLabel, IonSpinner } from '@ionic/react';
import { WITHOUT_OFFSET_TREATMENT_LENGTH } from 'application/pages/Locations/useLocations';
import { useTreatmentBuilder } from 'application/state/TreatmentContext';
import { sortBy } from 'lodash';
import * as React from 'react';

import { useContextTranslation } from '../../../../ui/translation';
import type { HookData, TreatmentLength } from '../../../types';

const LengthSelectorContent = ({
  treatmentLengths,
  selectedLength,
  onSelect,
}: {
  treatmentLengths: HookData<TreatmentLength[]>;
  selectedLength: TreatmentLength | null;
  onSelect: (treatmentType: TreatmentLength) => void;
}): JSX.Element => {
  const t = useContextTranslation('page.treatment');
  if (treatmentLengths.loading || !treatmentLengths.value) {
    return <IonSpinner name="dots" />;
  }

  const { location, isSpaBooking } = useTreatmentBuilder();

  const tls = treatmentLengths.value.map(treatmentLength => ({
    ...treatmentLength,

    length:
      location?.isWithoutOffset && !isSpaBooking
        ? treatmentLength.length - WITHOUT_OFFSET_TREATMENT_LENGTH
        : treatmentLength.length,
  }));

  return (
    <div className="selectable-container select-length">
      {sortBy(tls, ['length']).map(treatmentLength => (
        <IonItem
          className="treatment-type-item"
          color={
            selectedLength?.id === treatmentLength.id ? 'primary' : 'light'
          }
          key={treatmentLength.id}
          onClick={() => onSelect(treatmentLength)}
          lines="none"
        >
          <IonLabel
            color={
              selectedLength?.id === treatmentLength.id ? 'light' : 'primary'
            }
          >
            <span>
              <strong>
                {t('length_minutes', { length: treatmentLength.length })}
              </strong>
              &nbsp;/&nbsp;
              {t('length_price', { price: treatmentLength.price })}
            </span>
          </IonLabel>
        </IonItem>
      ))}
    </div>
  );
};

export default LengthSelectorContent;
